import Button from "components/Button";
import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";
import { colors } from "theme/colors";

export const CardWrapper = styled.div`
    background: #ffffff;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    border-radius: 14px;
    width: 100%;
    padding: 15px 17px;
    padding-left: 30px;
    margin-bottom: 30px;

    @media (${theme.breakpoints.mobileL}) {
        padding: 10px 15px;
    }
`;

export const PencilButton = styled(Button)`
    @media (${theme.breakpoints.mobileL}) {
        padding: 7px 9px;
    }
`;

export const CardTitleLeft = styled.div`
    display: flex;
    gap: 14px;
    align-items: center;

    svg {
        color: #00bbc7;
        font-size: 20px;
    }

    @media (${theme.breakpoints.mobileL}) {
        ${Text.Style} {
            font-size: 16px;
            font-weight: 600;
        }
    }
`;

export const BulletColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled(Text)`
    font-size: 14px;
    font-weight: 500;
    color: ${colors.grey.primary};
    margin-top: 5px;
    width: fit-content;

    @media (${theme.breakpoints.mobileL}) {
        font-size: 11px;
    }
`;

export const Bullet = styled.div`
    border: 1px solid #efefef;
    border-radius: 37px;
    width: fit-content;
    margin-top: 10px;
    padding: 8px 10px;
    padding-top: 5px;
    ${Text.Style} {
        color: ${colors.grey.dark};
        font-size: 14px;
        font-weight: 500;
    }

    @media (${theme.breakpoints.mobileL}) {
        margin-top: 5px;
        ${Text.Style} {
            font-size: 13px;
        }
    }
`;

export const ItalicText = styled(Text)`
    color: ${colors.grey.primary} !important;
    font-style: italic;
`;
